//Core
import React from "react"

//styles
import style from "./style.module.scss"

const Logo = ({ logo }) => {
  return (
    <div className={style.logo}>
      <a
        href="https://tascombank.ua/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={logo} alt={"Логотип Таскомбанк"}></img>
      </a>
    </div>
  )
}

export default Logo
